import React from 'react';
import { fetchDocumentStatus } from '../services/options_service';
import { InputTypeDropdown } from '.';

class InputDropdownStatus extends React.Component {
  state = {
    options: [],
  }

  componentDidMount() {
    this.fetchDocumentStatus();
  }

  fetchDocumentStatus = () => {
    fetchDocumentStatus()
      .then((data) => {
        this.setState({
          options: data,
        });
      });
  }

  render() {
    const { ...rest } = this.props;
    const { options } = this.state;

    return (
      <InputTypeDropdown
        field="document_status"
        label="Aprovação Documental"
        options={options}
        {...rest}
      />
    );
  }
}

export default InputDropdownStatus;
